import SpriteSymbol from "../../../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../config/webpack/loaders/svg-sprite/utils/sprite";
var symbol = new SpriteSymbol({
  "id": "icon__facebook",
  "use": "icon__facebook-usage",
  "viewBox": "0 0 24 23",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 23\" id=\"icon__facebook\"><path d=\"M23.612 11.669c0-6.337-5.104-11.473-11.4-11.473C5.912.196.809 5.332.809 11.67c0 5.727 4.175 10.474 9.63 11.331v-8.018H7.522V11.67h2.915V9.14c0-2.875 1.694-4.47 4.298-4.47 1.247 0 2.542.242 2.542.242v2.805H15.85c-1.415 0-1.869.892-1.869 1.799l.003 2.152h3.166l-.506 3.313h-2.66V23c5.455-.857 9.627-5.604 9.627-11.331z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol